var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRibbon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "640.000000pt",
    viewBox: "0 0 1280.000000 640.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,640.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2057 4303 c-4 -3 -7 -93 -7 -200 l0 -193 -1022 -2 -1022 -3 390 -443 c214 -244 390 -449 391 -455 1 -7 -175 -212 -391 -457 l-392 -445 1195 -3 c657 -1 1196 0 1198 2 2 2 -3 81 -11 175 -9 95 -16 181 -16 191 0 20 40 20 4030 20 3293 0 4030 -2 4030 -13 0 -7 -7 -91 -15 -186 -9 -96 -14 -175 -12 -177 2 -2 540 -3 1196 -2 l1193 3 -391 445 c-215 245 -389 450 -387 457 3 6 177 208 388 448 211 239 385 440 386 445 2 7 -363 10 -1012 10 l-1016 0 0 195 0 195 -4348 0 c-2392 0 -4352 -3 -4355 -7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.2cbd78f1a94b207f387b5c1fb6d9bc00.svg";
export { ForwardRef as ReactComponent };